// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__2TWUK","cell":"ColumnAccessor_cell__3LH3W","firstCellAccent":"ColumnAccessor_firstCellAccent__ekPt9"};